import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import PaymentsReceivedActions from '../../redux/reducers/payments_received_list_reducer/actions';
import useStyles from './styles';
import PaymentsReceivedDatatableList from './components/datatable';
import clsx from 'clsx';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { Translations } from './configuration';
import { PaymentsReceivedTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import PaymentsReceivedListActions from 'redux/reducers/payments_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import MessageIncomingViewXmlModal from './components/datatable/view';

const PaymentsReceivedPage = (props: any) => {
  // console.log('Render PaymentsReceived Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(PaymentsReceivedListActions.fetchMemberStateExcludeCyprusAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(PaymentsReceivedActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      PaymentsReceivedActions.fetchPaymentsReceivedListAction({
        sortField:
          PaymentsReceivedTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: PaymentsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          PaymentsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: PaymentsReceivedTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== PaymentsReceived Page ==================*/
    <div>
      <MessageIncomingViewXmlModal />
      {/*================== PaymentsReceived Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* PaymentsReceived Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <CreditCardIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of PaymentsReceived Page - Header ---------------*/}

      {/*================== PaymentsReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== PaymentsReceived Page - Body - PaymentsReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* PaymentsReceived Page - Body - PaymentsReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* PaymentsReceived Page - Body - PaymentsReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* PaymentsReceived Page - Body - PaymentsReceived Section - PaymentsReceived List Table */}
          <div className={classes.tableList}>
            <PaymentsReceivedDatatableList />
          </div>

          {/* PaymentsReceived Page - Body - PaymentsReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of PaymentsReceived Page - Body - PaymentsReceived Section ---------------*/}
      </div>
      {/*--------------- end of PaymentsReceived Page - Body ---------------*/}
    </div>
    /*--------------- end of PaymentsReceived Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(PaymentsReceivedPage);
